import { Pipe, PipeTransform } from '@angular/core';
import { RelationOperatorSearchText } from '@mtna/data-core-ts';

import { RdsChip } from '../chips/index';
import { getRdsDateFilterIso, RdsDateFilter } from '../core/models/filter/date-filter.model';

/**
 * Turn `RdsDateFilter` into RdsChips
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsDateFiltersToChips',
})
export class RdsDateFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsDateFilter> | null | undefined): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value.map((f) => {
      const iso: string = getRdsDateFilterIso(f);
      let id: string = f.operation?.type || '';
      id += f.value?.valueOf();
      const type = f.operation?.type;
      const operator = type ? RelationOperatorSearchText[type] : '';
      return new RdsChip(operator + ' ' + iso, id);
    });
  }
}
